import Option from '@/modules/common/models/option/option.ts';

export default class ClientOption extends Option<number> {
  constructor(response: any) {
    super(response, 'CLIENT_ID', 'Название', 'Доступен');
  }
}
